(function () {
  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var sync = function () {
      document.body.classList.toggle('rf-cart-open', drawer.classList.contains('active'));
    };
    var observer = new MutationObserver(sync);
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
